import { useRef, useState } from 'react'

import { useRequest } from 'ahooks'

import { toPageApi } from '../../../utils/crud'

import { UseRemoteSelectRequestProps } from './interface'

const DEFAULT_DATA: any[] = []

export const useRemoteSelectRequest = <T, P>({
  api,
  cacheKey,
  staleTime,
  readyRequest = true,
  requestParams,
  refreshDeps,
  onRequestSuccess
}: UseRemoteSelectRequestProps<T, P>) => {
  const currentRef = useRef(1)
  const pagesRef = useRef(0)
  const [state, setState] = useState({
    shouldSearch: false,
    data: DEFAULT_DATA as T[]
  })

  const { loading, error, runAsync, refreshAsync } = useRequest(
    toPageApi(api, {
      requestParams
    }),
    {
      manual: false,
      ready: readyRequest,
      cacheKey,
      staleTime,
      refreshDeps,
      refreshDepsAction: () => {
        runAsync({ current: 1 } as any)
      },
      onSuccess(data) {
        const { apiType, current, pages, list } = data
        currentRef.current = current
        pagesRef.current = pages
        setState(({ data }) => {
          return {
            shouldSearch: apiType === 'page',
            data: current > 1 ? data.concat(list) : list
          }
        })
        onRequestSuccess?.(data)
      }
    }
  )

  const fetchNextPage = () => {
    if (currentRef.current < pagesRef.current) {
      return runAsync({
        current: currentRef.current + 1
      } as any)
    }
  }

  const fetchSearch = (search: string) => {
    return runAsync({
      search,
      current: 1
    } as any)
  }

  return {
    ...state,
    error,
    loading,
    refreshAsync,
    fetchNextPage,
    fetchSearch
  }
}
